module.exports = __webpack_public_path__ + "static/media/carl987-049.e1bfcf91.jpg";